import { render, staticRenderFns } from "./CardSimulated.vue?vue&type=template&id=7dfe120c&scoped=true"
import script from "./CardSimulated.vue?vue&type=script&lang=js"
export * from "./CardSimulated.vue?vue&type=script&lang=js"
import style0 from "../styles/CardSimulated.css?vue&type=style&index=0&id=7dfe120c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfe120c",
  null
  
)

export default component.exports